module.exports = __webpack_public_path__ + "static/media/open_hamburger.318ad311.svg";